export default __webpack_public_path__ + "static/media/prasheet-pathak-post.622d1767.png";